import { Controller } from "stimulus"

// /videos/play?video_id=<id> (pages/videos-play.html): plays any Cloudflare
// Stream video from its id, whether or not it's listed on /videos. Emails
// can't embed a player, so a video's cover image in an email links here.
// Query parameters:
//
//   video_id  the Stream video id (32 hex characters), required
//   title     the heading and the tab's title, optional
//   poster    the player's cover image, a root-relative path on this site
//             (/assets/...jpg), optional; without it the player shows
//             Stream's own thumbnail
export default class VideoPlayController extends Controller {
  static get targets() { return ["player", "missing", "title"] }

  connect() {
    const params = new URLSearchParams(window.location.search)
    const videoId = (params.get("video_id") || "").trim().toLowerCase()
    if (!/^[0-9a-f]{32}$/.test(videoId)) {
      this.playerTarget.hidden = true
      this.missingTarget.hidden = false
      return
    }

    const title = (params.get("title") || "").trim()
    if (title) {
      this.titleTarget.textContent = title
      document.title = `${title} | Beekeeper Studio`
    }

    // The same player as _includes/cloudflare-video.html, plus autoplay, since
    // the reader just clicked a play button. Only a poster from this site, so
    // a crafted link can't put someone else's image on the page.
    const query = new URLSearchParams({ primaryColor: "#fad83b", autoplay: "true" })
    const poster = params.get("poster") || ""
    if (/^\/[^/\\]/.test(poster)) query.set("poster", window.location.origin + poster)

    const iframe = document.createElement("iframe")
    iframe.src = `https://customer-${this.data.get("customer")}.cloudflarestream.com/${videoId}/iframe?${query}`
    iframe.allow = "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
    iframe.setAttribute("allowfullscreen", "true")
    this.playerTarget.replaceChildren(iframe)
  }
}
